/*
 * @Auther: 罗耀祖
 * @Date: 2021-07-28 13:41:54
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-08-11 10:22:05
 * @name: 用户模块api
 * @Description: 用户模块api
 * @FilePath: \backstage\src\api\user\user.api.js
 * @Author: DESKTOP-1QU67QM
 */
import apiAdd from "../apiAdd.js";
import apiEdit from "../apiEdit.js";
import apiDelete from "../apiDelete.js";
import apiSearch from "../apiSearch.js";
import axios from 'axios';

/**
 * @Auther: 罗耀祖
 * @LastEditors: 罗耀祖
 * @description: 登录
 * @param {Object} data -> {username{String}: 用户名,password{String}: 密码, verify{String}: 验证码}
 */
export const login = (data) => {
  const instance = axios.create();
  const apiSearchInstance = new apiSearch();
  return apiSearchInstance.post('/admin/user/login.html', data, instance);
}